module.exports = __webpack_public_path__ + "front/img/main-img-wap.67f75813.png";